import { render, staticRenderFns } from "./HeppiPlan.vue?vue&type=template&id=0ca2c114"
import script from "./HeppiPlan.vue?vue&type=script&lang=js"
export * from "./HeppiPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports